import React, { useContext, useState } from 'react';
import { Redirect } from 'react-router-dom';
import axios from 'axios';
import cloneDeep from 'lodash.clonedeep';
import TextField from '@material-ui/core/TextField';
import Enums from '../../enums';
import Utils from '../../utils';
import Storage from '../../storage';
import Constants from '../../constants';
import './NormalLogin.scss';
import Spinner from '../../Components/Spinner/Spinner';
import { Button } from '@material-ui/core';
import LocationService from '../../Store/LocationsService/LocationsService'
import { LocationServiceContext } from '../../Store/LocationsService/LocationServiceProvider';
import { InputLabel } from "@material-ui/core";
import Modal from '../../Components/Modal/Modal';
import UserService from '../../Store/UserService';
/**
 * Represents the normal admin dashboard login component.
 */

const NormalLogin = () => {
    const {
        allLocationKeys,
        setAllLocationKeys,
        setAllLocations,
        selectedLocationKeys,
        setSelectedLocationKeys
    } = useContext(LocationServiceContext);
    const [currentLocKeyIds, setCurrentLocKeyIds] = useState([]);
    const [_formErrorSetClean, set_formErrorSetClean] = useState({
        isValid: true,
        username: '',
        password: '',
        serverError: '',
        unauthorized: ''
    });
    const [state, setstate] = useState({
        disableLoginBtn: false,
        formErrors: cloneDeep(_formErrorSetClean),
        isVisible: false,
        username: '',
        password: '',
        redirectToCoverSearch: false,
        showLoadingOverlay: false,
        redirectToDashbaord: false
    });

    //Show modal for otp validation
    const [showOtpModal, setShowOtpModal] = useState(false);

    const _isFormValid = () => {
        let isValid = true;
        const {
            username,
            password
        } = state;
        const formErrors = cloneDeep(_formErrorSetClean);

        if (!username) {
            isValid = false;
            formErrors.username = 'Username is required';
        }

        if (!password) {
            isValid = false;
            formErrors.password = 'Password is required';
        }
        setstate({ ...state, formErrors: formErrors })
        // this.setState(() => ({ formErrors: formErrors }));

        return isValid;
    }

    const _onInputChange = (path, value) => {
        Utils.update(state, path, value);

        setstate({ ...state, state })
    }

    //handle OTP validation
    const [inputOtp, setInputOtp] = useState(0);
    const [validOTP, setValidOTP] = useState(false);
    const handleOtpModalChange = (e) => {
        setInputOtp(e.target.value);
    }

    const OtpValidateAuth = async () => {
        let auth = Storage.getItem("key")
        let auth2 = inputOtp

        const body = {
            OTP: auth,
            OTP2: auth2,
            Username: state.username,
            Password: state.password
        };

        const url = `${process.env.REACT_APP_AUTHENTICATION_API}/AuthenticateOTP`;
        await axios.post(url, body).then(res => {
            setValidOTP(true);
            _onLogin()
        })
            .catch(err => {
                alert(err.response.data.ResponseMessage);
            });
    }

    //

    const _onKeyPress = (e) => {
        const {
            key
        } = e;

        if (key === Enums.KeyboardKeys.enterKey) {
            _onLogin();
        }
    }

    const getLocations = async () => {
        LocationService.getLocations().then((resp) => {
            try {
                if (resp) {
                    const myLocations = LocationService.updateLocationStore(resp);
                    setSelectedLocationKeys(myLocations)
                    setAllLocations(myLocations);

                    const myLocationKeys = LocationService.getCacheLocations()
                    LocationService.updateLocKeys(myLocationKeys);
                    setstate({ ...state, redirectToDashbaord: true });
                }
            } catch (err) {
            }
        })
    }

    const _onLogin = async () => {
        Storage.removeItem("key");
        if (_isFormValid()) {
            try {

                setstate({ ...state, showLoadingOverlay: true })
                // this.setState(() => ({ showLoadingOverlay: true }));
                setstate({ ...state, disableLoginBtn: true })
                // this.setState(() => ({ disableLoginBtn: true }));

                const url = `${process.env.REACT_APP_AUTHENTICATION_API}/Login`;
                // const {
                //   username,
                //   password
                // } = this.state;
                const data = {
                    username: state.username,
                    password: state.password
                };
                const res = await axios.post(url, data);

                const jwt = res.data;
                const jwtData = Utils.decodeJwt(jwt);

                if (jwtData.OTP != 0) {
                    Storage.setItem('key', jwtData.OTP);
                    setShowOtpModal(true);
                }
                else {
                    setValidOTP(true);
                    let user = Storage.getItem(Constants.currUserKey);
                    let sid = jwtData[Constants.sessionIDKey];

                    Storage.setItem('userRole', jwtData.role);
                    Storage.setItem('sessionID', sid);
                    let familyName = jwtData[Constants.familyName];
                    Storage.setItem('familyName', familyName);

                    if (!user) {
                        user = {
                            jwt: ''
                        };
                    }

                    user.jwt = jwt;
                    Storage.setItem(Constants.currUserKey, user);
                    // this.setState(() => ({ redirectToCoverSearch: true }));

                    if (jwtData.role.indexOf('user') >= 0 || jwtData.role.indexOf('superadmin') >= 0) {
                        const url = `${process.env.REACT_APP_CUSTOMER_API}/allCoverKeys`;
                        const res = await axios.get(url);

                        if (res?.data) {
                            if (res.data.length === 1) {
                                await UserService.getElementsForUserCoverKey();
                                //Locations logic here
                                await getLocations();
                            } else
                                setstate({ ...state, redirectToCoverSearch: true })
                        }
                    }
                    else {
                        await UserService.getElementsForUserCoverKey();
                        setstate({ ...state, redirectToDashbaord: true })
                    }
                }

            } catch (error) {
                if ((error && !error.response) || (error && error.response.status === Enums.HttpStatusCodes.httpStatusUnauthorizedError)) {
                    setstate({
                        ...state,
                        disableLoginBtn: false,
                        showLoadingOverlay: false,
                        formErrors: {
                            serverError: 'Invalid username or password'
                        }
                    });
                } else if ((error && !error.response) || (error && error.response.status === Enums.HttpStatusCodes.httpStatusInternalServerError)) {
                    setstate({
                        ...state,
                        disableLoginBtn: false,
                        showLoadingOverlay: false,
                        formErrors: { serverError: 'Unable to login at this time' }
                    });
                } else if ((error && !error.response) || (error && error.response.status === Enums.HttpStatusCodes.httpStatusAccountLockdError)) {
                    setstate({
                        ...state,
                        disableLoginBtn: false,
                        showLoadingOverlay: false,
                        formErrors: { serverError: 'Account is disabled' }
                    });
                } else if ((error && !error.response) || (error && error.response.status === Enums.HttpStatusCodes.httpStatusExpiredPasswordError)) {
                    setstate({
                        ...state,
                        disableLoginBtn: false,
                        showLoadingOverlay: false,
                        formErrors: { serverError: 'Your password has expired, it is time to change it.' }
                    });
                    window.location.href = error.response.data.message;
                }
            }

            const apiKeybooking = `${process.env.REACT_APP_API_KEY}`;
            let apibooking = `${process.env.REACT_APP_PROD_SWITCH_API}?secretCode=${apiKeybooking}&moduleName=Online%20Booking%20Setup`;
            const resultbooking = await axios.get(apibooking);
            Storage.setItem('showonlinebooking', resultbooking.data);

            const apiKeyreg = `${process.env.REACT_APP_API_KEY}`;
            let apireg = `${process.env.REACT_APP_PROD_SWITCH_API}?secretCode=${apiKeyreg}&moduleName=Form%20Registration`;
            const resultreg = await axios.get(apireg);
            Storage.setItem('showregistration', resultreg.data);
        }
    };

    if (Storage.getItem(Constants.sessionID) !== null && !state.redirectToCoverSearch) {
        window.location.href = "/welcome"  //<Redirect to={{pathname: `/communications/chat`}}/>;
    }

    if (Storage.getItem(Constants.sessionID) !== null && !state.redirectToCoverSearch) {
        window.location.href = "/welcome"  // <Redirect to={{pathname: `/communications/chat`}}/>;
    }

    if (state.redirectToCoverSearch) {

        return <Redirect to={{ pathname: `/chooseCoverUser` }} />;
    }

    if (state.redirectToDashbaord) {
        window.location.href = "/welcome"  // <Redirect to={{pathname: `/communications/chat`}}/>;
    }

    const { formErrors, username, password, showLoadingOverlay, disableLoginBtn } = state
    return (
        <>
            <div className="login-norm">
                <h3 className="login-norm__subtitle">{'SIGN IN TO YOUR ACCOUNT'}</h3>
                <form className="login-norm__form">
                    <TextField
                        className="login-norm__input"
                        inputProps={{
                            style: {
                                padding: '12px 14px'
                            }
                        }}
                        label={'Username'}
                        value={username}
                        variant="outlined"
                        onChange={(e) => _onInputChange(['username'], e.target.value)}
                        onKeyPress={_onKeyPress} />
                    <span
                        className={`login-norm__error ${formErrors.username ? 'login-norm__error--visible' : ''}`}>{formErrors.username}</span>
                    <TextField
                        className="login-norm__input"
                        inputProps={{
                            style: {
                                padding: '12px 14px'
                            }
                        }}
                        label={'Password'}
                        type="password"
                        value={password}
                        variant="outlined"
                        onChange={(e) => _onInputChange(['password'], e.target.value)}
                        onKeyPress={_onKeyPress} />
                    <span
                        className={`login-norm__error login-norm__error--no-margin ${formErrors.password ? 'login-norm__error--visible' : ''}`}>{formErrors.password}</span>
                    <span
                        className={`login-norm__error login-norm__error--no-margin${formErrors.unauthorized ? 'login-norm__error--visible' : ''}`}>{formErrors.unauthorized}</span>
                    <span
                        className={`login-norm__error login-norm__error--no-margin ${formErrors.serverError ? 'login-norm__error--visible' : ''}`}>{formErrors.serverError}</span>
                    <p />
                    <p />
                    {!showLoadingOverlay && <Button
                        className="login-norm__login"
                        disabled={disableLoginBtn}
                        type="button"
                        variant='contained'
                        color='primary'
                        onClick={_onLogin}>
                        {'Sign In'}
                    </Button>}
                    {showLoadingOverlay && <Button
                        className="login-norm__login btn-loading-holder"
                        variant='outlined'
                        color='primary'
                        type="button">
                        {'Signing In'} <span className='btn-loading spinner-invert'><Spinner /></span>
                    </Button>}
                    <p>
                        Forget your password?
                    </p>
                    <p>
                        <a href="https://www.4patientcare.ws/dashboardv3/Web/Passwdreset.aspx?DashboardV=true">Click here to reset your password.</a>
                    </p>
                    <span className='hipaa-message'>
                        Warning: This system contains Protected Information and is for authorized use only.
                        All system activities and transactions are logged. Unauthorized or improper use of
                        this system may result in civil and criminal penalties. By continuing to use this system,
                        you indicate your awareness of and consent to these terms and conditions of use.
                    </span>
                </form>
                {/*<Overlay show={showLoadingOverlay}>
          <i className="spinner-eclipse"></i>
        </Overlay>*/}

                <Modal show={showOtpModal} hideCloseButton={true}>
                    <h3>Please Validate OTP</h3>
                    <hr />
                    <p>For your added protection, we required to enable you Multi-Factor Authentication to your account. We sent a
                        One-Time Pin on your email address.
                    </p>
                    <center>
                        <input type='text' onChange={handleOtpModalChange} name="otp" />
                    </center>
                    <hr />
                    <button type='button' className="login-norm__login" onClick={OtpValidateAuth}>Submit</button>
                </Modal>
            </div>
        </>
    )
    //}
}
export default NormalLogin;
